/**
 * Utilidades para manejar días hábiles y zona horaria de Buenos Aires
 */

/**
 * Obtiene la fecha actual en la zona horaria de Buenos Aires
 */
export const getBuenosAiresDate = (): Date => {
  // Buenos Aires está en UTC-3 (Argentina Time)
  const now = new Date();
  const buenosAiresOffset = -3 * 60; // -3 horas en minutos
  const localOffset = now.getTimezoneOffset(); // Offset local en minutos
  const offsetDiff = buenosAiresOffset + localOffset;
  
  return new Date(now.getTime() + (offsetDiff * 60 * 1000));
};

/**
 * Verifica si una fecha es un día hábil (lunes a viernes)
 */
export const isBusinessDay = (date: Date): boolean => {
  const dayOfWeek = date.getDay();
  return dayOfWeek >= 1 && dayOfWeek <= 5; // 1 = lunes, 5 = viernes
};

/**
 * Calcula el siguiente día hábil a partir de una fecha dada
 */
export const getNextBusinessDay = (date: Date): Date => {
  const nextDay = new Date(date);
  
  do {
    nextDay.setDate(nextDay.getDate() + 1);
  } while (!isBusinessDay(nextDay));
  
  return nextDay;
};

/**
 * Verifica si es medianoche en Buenos Aires (00:00)
 */
export const isMidnightBuenosAires = (): boolean => {
  const buenosAiresTime = getBuenosAiresDate();
  return buenosAiresTime.getHours() === 0 && buenosAiresTime.getMinutes() === 0;
};

/**
 * Formatea una fecha como string YYYY-MM-DD
 */
export const formatDateToString = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Convierte un string de fecha YYYY-MM-DD a Date
 */
export const parseDateString = (dateString: string): Date => {
  return new Date(dateString + 'T00:00:00');
};

/**
 * Verifica si una fecha es hoy en Buenos Aires
 */
export const isTodayInBuenosAires = (dateString: string): boolean => {
  const date = parseDateString(dateString);
  const today = getBuenosAiresDate();
  
  return date.getFullYear() === today.getFullYear() &&
         date.getMonth() === today.getMonth() &&
         date.getDate() === today.getDate();
};

/**
 * Obtiene la fecha de ayer en Buenos Aires
 */
export const getYesterdayInBuenosAires = (): Date => {
  const yesterday = getBuenosAiresDate();
  yesterday.setDate(yesterday.getDate() - 1);
  return yesterday;
};

/**
 * Verifica si una fecha es ayer en Buenos Aires
 */
export const isYesterdayInBuenosAires = (dateString: string): boolean => {
  const date = parseDateString(dateString);
  const yesterday = getYesterdayInBuenosAires();
  
  return date.getFullYear() === yesterday.getFullYear() &&
         date.getMonth() === yesterday.getMonth() &&
         date.getDate() === yesterday.getDate();
};
